var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("Herzlich willkommen zum NAJU-Sharepic-Generator.")]),_c('button',{staticClass:"btn primary",attrs:{"type":"button"},on:{"click":_vm.next}},[_vm._v(" Sharepic erstellen ")])])}
var staticRenderFns = []

export { render, staticRenderFns }